import { ProductIngredientTypeEnum } from '@/apis/rest/generated/types'
import { useRecommendIngredientProductsQuery } from '@/graphql/generated/hooks'
import { GraphQLProductType } from '@/utils/product/product-card.util'

export const useQueryRecommendIngredientProductsQuery = ({
  productId,
  feedIngredientType,
}: {
  productId: string
  feedIngredientType?: ProductIngredientTypeEnum
}) => {
  const { data, loading: isLoading } = useRecommendIngredientProductsQuery({
    fetchPolicy: 'cache-first',
    variables: {
      id: productId,
      feedIngredientType,
    },
  })

  return {
    data:
      (data?.ingredientBasedFeedRecommendationProducts?.edges.map((e) => ({
        ...e.node,
      })) as unknown as GraphQLProductType[]) || [],
    isLoading,
  }
}
